import React from "react";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import { Tooltip } from "@mui/material";

const iconStyle = {
    height: "16px",
    width: "16px",
    cursor: "pointer"
};

const InfoTooltip = ({ title = "" }) => {
    return (
        <Tooltip
            title={title}
            componentsProps={{
                tooltip: {
                    sx: {
                        whiteSpace: "pre-line"
                    }
                }
            }}
        >
            <QuestionMarkIcon sx={iconStyle} color="primary" />
        </Tooltip>
    );
};

export default InfoTooltip;
